var ValueJS = ValueJS || {};

ValueJS.MiniCart = function() {

    var _miniCartOffCanvas = null;
    var _miniCartAlert = null;

    var _init = function() {
        // check if not cart template
        if ($('body').hasClass('template--cart')) {
            return;
        }

        _miniCartOffCanvas = new bootstrap.Offcanvas('#MiniCart');
        _miniCartAlert = $('#MiniCart .mini-cart__alert');

        // handle add to cart
        $('form.shopify-product-form').on('submit', function(e) {
            e.preventDefault();
            $.ajax({
                type: 'POST',
                url: '/cart/add.js',
                dataType: 'json',
                data: $(this).serialize()
            })
            .done(function(data, status, request){
                _update();
                _alert('success', 'Product added successfully to your cart.')
                _miniCartOffCanvas.show();
                // ValueJS.BootstrapToast.create('Product successfully added to cart.');
            })
            .fail(function(request, status, error){
                // ValueJS.Bootstrap.Toast.show('error', request.responseJSON.description);
                // ValueJS.BootstrapToast.create(request.responseJSON.description);
                _update();
                _alert('danger', request.responseJSON.description)
                _miniCartOffCanvas.show();
            });
        });
        // handle remove item
        $('.mini-cart__items').on('click', '.cart-item__remove', function(event) {
            event.preventDefault();
            let cartItem = $(this).parents('.mini-cart__item');
            $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                dataType: 'json',
                data: {
                    id: cartItem.data('line-item-id'),
                    quantity: 0
                }
            })
            .done(function(data, status, request){
                // _update();
                // ValueJS.BootstrapToast.create('Product successfully removed from cart.');
                _update();
                _alert('success', 'Product removed successfully from your cart.')
                _miniCartOffCanvas.show();
            })
            .fail(function(request, status, error){
                // ValueJS.Bootstrap.Toast.show('error', request.responseJSON.description);
                _update();
                _alert('danger', request.responseJSON.description)
                _miniCartOffCanvas.show();
            });
        });
    }

    var _alert = function(type, msg) {
        let output = '';

        output += '<div class="alert alert-' + type + ' alert-dismissible fade show mb-4" role="alert">';
            output += msg;
            output += '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>';
        output += '</div>';

        _miniCartAlert.html(output);
    }

    var _update = function() {
        $.ajax({
            type: 'GET',
            url: '/cart.js',
            dataType: 'json'
        })
        .done(function(data, status, request){
            // insert items in cart
            let cartBody = $('.mini-cart__items').html('');
            data.items.forEach(function (item, index) {
                let itemRow = '';

                // itemRow += '<div class="mini-cart__item row mb-3" data-line-item-id="'+ item.id +'">';
                //     itemRow += '<div class="col-2">';
                //         itemRow += '<a href="' + item.url + '">';
                //             itemRow += '<img class="img-fluid lazy" src="' + item.featured_image.url + '&width=60" alt="' + item.title + '"/>';
                //         itemRow += '</a>';
                //     itemRow += '</div>';
                //     itemRow += '<div class="col-8">';
                //         itemRow += '<h3 class="h5 cart-item__title position-relative mb-0">';
                //             itemRow += '<span class="fw-bolder text-uppercase">' + item.product_title.replace(' ' + item.variant_options[2], ' ') + '</span>';
                //             itemRow += '<small class="text-muted"> ' + item.variant_title + '</small>';
                //             itemRow += '<a class="stretched-link" href="' + item.url + '"></a>';
                //         itemRow += '</h3>';
                //         itemRow += '<div class="cart-item__unit-price">';
                //             if (item.total_discount > 0) {
                //                 itemRow += '<del class="text-black-50"><small>' + Shopify.formatMoney(item.original_price, '{{amount}} EUR') + '</small></del>&nbsp;';
                //             }
                //             itemRow += Shopify.formatMoney(item.discounted_price, '{{amount}} EUR');
                //         itemRow += '</div>';
                //         itemRow += '<a class="cart-item__remove text-xs" role="button" href=""><i class="fa-regular fa-trash-can"></i></a>';
                //     itemRow += '</div>';
                //     itemRow += '<div class="col-2 cart-item__quantity text-end text-sm">x ' + item.quantity + '</div>';
                // itemRow += '</div>';

                // itemRow += '<div class="mini-cart__item row mb-3" data-line-item-id="'+ item.id +'">';
                //     itemRow += '<div class="col-2">';
                //         itemRow += '<a href="' + item.url + '">';
                //             itemRow += '<img class="img-fluid" src="' + item.featured_image.url + '&width=60" alt="' + item.title + '"/>';
                //         itemRow += '</a>';
                //     itemRow += '</div>';
                //     itemRow += '<div class="col-8">';
                //         itemRow += '<h3 class="h5 cart-item__title mb-0 fw-bolder text-uppercase position-relative">';
                //             itemRow += '<small class="cart-item__quantity fw-light text-muted">'+ item.quantity +'x</small> ';
                //             itemRow += item.product_title.replace(' ' + item.variant_options[2], '');
                //             itemRow += '<a class="stretched-link" href="' + item.url + '"></a>';
                //         itemRow += '</h3>';
                //         itemRow += '<div class="d-flex ">';
                //             itemRow += '<span class="text-muted"> ' + item.variant_title + '</span>';
                //         itemRow += '</div>';
                //         itemRow += '<div class="cart-item__unit-price">';
                //             if (item.total_discount > 0) {
                //                 itemRow += '<del class="text-black-50"><small>' + Shopify.formatMoney(item.original_price, '{{amount}} EUR') + '</small></del>&nbsp;';
                //             }
                //             itemRow += Shopify.formatMoney(item.discounted_price, '{{amount}} EUR');
                //         itemRow += '</div>';
                //     itemRow += '</div>';
                //     itemRow += '<div class="col-2 text-end text-sm"><a class="cart-item__remove text-xs" role="button" href=""><i class="fa-regular fa-trash-can"></i></a></div>';
                // itemRow += '</div>';

                itemRow += '<div class="mini-cart__item row mb-3" data-line-item-id="'+ item.id +'">';
                    itemRow += '<div class="col-2">';
                        itemRow += '<a href="' + item.url + '">';
                            itemRow += '<img class="img-fluid" src="' + item.featured_image.url + '&width=40&height=60&crop=center" alt="' + item.title + '"/>';
                        itemRow += '</a>';
                    itemRow += '</div>';
                    itemRow += '<div class="col-10">';

                        itemRow += '<div class="d-flex justify-content-between">';
                            itemRow += '<h3 class="h5 cart-item__title mb-0 position-relative">';
                                itemRow += '<small class="cart-item__quantity fw-light text-muted text-lowercase">'+ item.quantity +'x</small> ';
                                itemRow += item.product_title.replace(' ' + item.variant_options[2], '');
                                itemRow += '<a class="stretched-link" href="' + item.url + '"></a>';
                            itemRow += '</h3>';
                            itemRow += '<small class="cart-item__unit-price text-muted">';
                                if (item.total_discount > 0) {
                                    itemRow += '<del class="text-black-50"><small>' + Shopify.formatMoney(item.original_price, '{{amount}} EUR') + '</small></del>&nbsp;';
                                }
                                itemRow += Shopify.formatMoney(item.discounted_price, '{{amount}} EUR');
                            itemRow += '</small>';
                        itemRow += '</div>';

                        itemRow += '<div class="d-flex justify-content-between">';
                            itemRow += '<p class="text-muted"><small>' + item.variant_title + '</small></p>';
                            itemRow += '<a class="cart-item__remove text-xs mt-1" role="button" href=""><i class="fa-solid fa-delete-left"></i></a>';
                        itemRow += '</div>';
                    itemRow += '</div>';
                itemRow += '</div>';

                cartBody.append(itemRow);
            });
            // update cart total price
            $('.mini-cart__orig-total-price').html(Shopify.formatMoney(data.original_total_price, '{{amount}} EUR'));
            $('.mini-cart__total-price').html(Shopify.formatMoney(data.total_price, '{{amount}} EUR'));
            if (data.total_price < data.original_total_price) {
                $('.mini-cart__orig-total-price').removeClass('d-none');
            } else {
                $('.mini-cart__orig-total-price').addClass('d-none');
            }
            // show or hide cart empty msg + checkout
            if (data.items.length > 0) {
                $('.mini-cart__empty').addClass('d-none')
                $('.mini-cart__checkout').removeClass('d-none')
            } else {
                $('.mini-cart__empty').removeClass('d-none');
                $('.mini-cart__checkout').addClass('d-none')
            }
            // update cart item count
            $('.mini-cart__item-count').text(data.item_count);
        });
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
        update : function() {return _update();}
    };

}();

$(function() {
    ValueJS.MiniCart.init();
    ValueJS.MiniCart.update();
});
